<template>
  <div class="content" id="contents">
    <HeaderNav />
    <router-view></router-view>
    <FooterBox />
  </div>
</template>

<script setup>
  import HeaderNav from '@/components/HeaderNav.vue';
  import FooterBox from '@/components/FooterBox.vue'
  import { watch } from 'vue'
  import { useRoute } from 'vue-router'
  const route = useRoute()
  // 监听路由变化
  watch(
    () => route.path, // 监听 path 变化
    (newPath, oldPath) => {
      let box = document.getElementById('contents')
      box.scrollTo(0, 0);
    }
  )
</script>

<style>
html, body, #app,.content {
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}
</style>
